import { normalizeStorageKey, storageKeyFromUrl } from './storageKey';

// This guards against stale session tracks, not access to audio bytes. The
// backend authorizes user-library IDs before resolving their private files.
export function isTrackInSessionScope(sessionId, track) {
  if (!track) return false;
  if (track.type === 'instrument' || track.sourceType === 'stock') return true;
  // An imported library recording can retain the storage path of its original
  // upload session. Its stable, resolved library identity travels with it.
  if (track.sourceType === 'user' && /^user-[a-zA-Z0-9_-]+$/.test(track.assetId || '')
    && track.loopSource?.assetId === track.assetId) return true;
  const key = normalizeStorageKey(track.storageKey) || storageKeyFromUrl(track.fileUrl);
  if (!key) return true;
  const lower = key.toLowerCase();
  const code = String(sessionId || '').toLowerCase();
  return lower.startsWith(`sessions/${code}/`) || lower.startsWith(`env=prod/sessions/${code}/`);
}
